import { render, staticRenderFns } from "./_theme.vue?vue&type=template&id=4e75964a&lang=pug"
import script from "./_theme.vue?vue&type=script&lang=js"
export * from "./_theme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports